
(function () {
  'use strict';

  const SELECTED =
    'input[name^="kaching-bundles-deal-"]:checked';

  const BUTTON = '.product-form__submit';

  const MONEY_REGEX =
    /(?:€\s*[\d.,]+|[\d.,]+\s*€)/g;

  function getPrices() {
    const selected = document.querySelector(SELECTED);
    if (!selected) return null;

    const bundle = selected.closest(
      '.kaching-bundles__bar'
    );

    const pricing = bundle?.querySelector(
      '.kaching-bundles__bar-pricing'
    );

    if (!pricing) return null;

    const matches = (
      pricing.innerText ||
      pricing.textContent ||
      ''
    ).match(MONEY_REGEX);

    if (!matches?.length) return null;

    return {
      current: matches[0].trim(),
      previous: matches[1]?.trim() || ''
    };
  }

  function updateButton() {
    const button = document.querySelector(BUTTON);
    const prices = getPrices();

    if (!button || !prices) return;

    // Não substituímos mais os elementos do botão.
    // O conteúdo original permanece no DOM.
    const originalSpan = button.querySelector(
      ':scope > span:not(.erolen-button-content)'
    );

    if (!originalSpan) return;

    let display = button.querySelector(
      ':scope > .erolen-button-content'
    );

    if (!display) {
      display = document.createElement('span');
      display.className = 'erolen-button-content';

      display.setAttribute('aria-hidden', 'true');

      button.appendChild(display);
    }

    // Esconde visualmente o texto original,
    // mantendo-o presente para o Dawn/Kaching.
    originalSpan.style.position = 'absolute';
    originalSpan.style.width = '1px';
    originalSpan.style.height = '1px';
    originalSpan.style.padding = '0';
    originalSpan.style.margin = '-1px';
    originalSpan.style.overflow = 'hidden';
    originalSpan.style.clip = 'rect(0, 0, 0, 0)';
    originalSpan.style.whiteSpace = 'nowrap';
    originalSpan.style.border = '0';

    const key =
      prices.current + '|' + prices.previous;

    if (display.dataset.priceKey === key) return;

    display.dataset.priceKey = key;
    display.replaceChildren();

    const main = document.createElement('span');
    main.className = 'erolen-button-main';

    main.append(
      document.createTextNode(
        'In den Warenkorb · ' + prices.current
      )
    );

    if (prices.previous) {
      const oldPrice = document.createElement('span');
      oldPrice.className = 'erolen-button-old';
      oldPrice.textContent = prices.previous;
      main.appendChild(oldPrice);
    }

    const subtitle = document.createElement('span');
    subtitle.className = 'erolen-button-sub';
    subtitle.textContent =
      '✓ Kostenloser Versand · 120 Tage Geld-zurück-Garantie';

    display.append(main, subtitle);
    button.classList.add('erolen-buy-button');
  }

  function init() {
    // Aguarda o Kaching carregar o kit inicial.
    let attempts = 0;

    const interval = setInterval(function () {
      updateButton();

      attempts++;

      if (attempts >= 40) {
        clearInterval(interval);
      }
    }, 250);

    // Atualiza ao trocar de kit.
    document.addEventListener('change', function (event) {
      if (
        event.target.matches(
          'input[name^="kaching-bundles-deal-"]'
        )
      ) {
        setTimeout(updateButton, 100);
        setTimeout(updateButton, 350);
      }
    });

    document.addEventListener('click', function (event) {
      if (
        event.target.closest('.kaching-bundles__bar')
      ) {
        setTimeout(updateButton, 150);
      }
    });

    updateButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();
